const RECOVERY_STORAGE_KEY = 'wn-lazy-chunk-recovery';
const RECOVERY_WINDOW_MS = 15_000;

export function recoverFromLazyChunkFailure(error: unknown): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const message = readErrorMessage(error);
  if (!isLazyChunkFailure(message)) {
    return false;
  }

  const currentUrl = window.location.href;
  const now = Date.now();
  const previous = window.sessionStorage.getItem(RECOVERY_STORAGE_KEY);

  if (previous) {
    try {
      const parsed = JSON.parse(previous) as { url?: string; at?: number };
      if (parsed.url === currentUrl && typeof parsed.at === 'number' && now - parsed.at < RECOVERY_WINDOW_MS) {
        window.sessionStorage.removeItem(RECOVERY_STORAGE_KEY);
        return false;
      }
    } catch {
      window.sessionStorage.removeItem(RECOVERY_STORAGE_KEY);
    }
  }

  window.sessionStorage.setItem(
    RECOVERY_STORAGE_KEY,
    JSON.stringify({
      url: currentUrl,
      at: now
    })
  );

  window.location.reload();
  return true;
}

function isLazyChunkFailure(message: string): boolean {
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed') ||
    /Loading chunk [^ ]+ failed/i.test(message)
  );
}

function readErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    return typeof message === 'string' ? message : '';
  }

  return '';
}
